export const label = 'Додаткова інформація про відправлення (не обов’язково)';
export const maxLength = 100;
export const errors = {
  maxlength: `Максимальна довжина ${maxLength} символів`,
};
